/// <reference path="InvoiceLineReconciliationDataSource.ts" />

// The sales invoices of the reconciliation list (licence invoices included), from their lines.
class SalesInvoiceLineReconciliationDataSource extends InvoiceLineReconciliationDataSource
{
    protected lineEntityName() : string {
        return "SalesInvoiceLine";
    }

    protected prefetchKeyPaths() : string[] {
        return [
            "document.legalEntity.salesLedgerAccount",
            "document.ledgerAccount",
            "document.journalEntry",
            "document.business",
            "document.distributor.salesLedgerAccount",
            "ledgerAccount",
            "journalEntry",
            "lineClassification.ledgerAccount",
            "product.salesLedgerAccount",
            "conceptItem.salesLedgerAccount",
            "vat.salesLedgerAccount"
        ];
    }
}
